// A V4 tone enum value looks like "tone1".."tone12" (no underscore).
export const isToneValue = (value) => /^tone\d+$/i.test(String(value ?? "").trim());

// Map a tone value to its bundled mp3, choosing the P4/P5 set from the device.
// Returns null for non-tone / out-of-range values so callers can disable play.
export const getToneAsset = (value, isTwigP5) => {
  const match = /^tone(\d+)$/i.exec(String(value ?? "").trim());
  if (!match) return null;
  const n = Number(match[1]);
  if (!(n >= 1 && n <= 12)) return null;
  const prefix = isTwigP5 ? "Twig_P5" : "Twig_P4";
  try {
    return require(`../../assets/sound/${prefix}_${n}.mp3`);
  } catch (e) {
    return null;
  }
};
